import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("asv_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  // Never serve stale list/detail data from the browser HTTP cache.
  if ((config.method || "get").toLowerCase() === "get") {
    config.headers["Cache-Control"] = "no-cache";
    config.headers["Pragma"] = "no-cache";
    config.params = { ...(config.params || {}), _: Date.now() };
  }
  return config;
});

export const money = (n) =>
  (Number(n || 0) < 0 ? "-" : "") + "₹" + Math.abs(Number(n || 0)).toLocaleString("en-IN", { maximumFractionDigits: 2 });

export const num = (n) =>
  Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });

export const fmtDate = (d) => {
  if (!d) return "-";
  try {
    const dt = new Date(d.length <= 10 ? d + "T00:00:00" : d);
    return dt.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return d;
  }
};

export const toCSV = (rows, filename) => {
  if (!rows || !rows.length) return;
  const cols = Object.keys(rows[0]).filter((k) => typeof rows[0][k] !== "object");
  const head = cols.join(",");
  const body = rows
    .map((r) =>
      cols
        .map((c) => {
          const v = r[c] == null ? "" : String(r[c]).replace(/"/g, '""');
          return `"${v}"`;
        })
        .join(",")
    )
    .join("\n");
  const blob = new Blob([head + "\n" + body], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "export.csv";
  a.click();
  URL.revokeObjectURL(url);
};
